import React, { useEffect, useMemo } from 'react';
import useCurrentContextMenu from "@/common/hooks/useCurrentContextMenu";
import { ContextMenuTypes } from "@/enum/contextMenuTypes";

const useMuiFillerContextMenu = () => {
  const SELECTORS = useMemo(() => [
    ".MuiDataGrid-filler",
    ".MuiDataGrid-overlay"
  ], []);
  const [, setCurrentContextMenu] = useCurrentContextMenu();

  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the closest matches any selector in the array
      const isFiller = SELECTORS.some(selector => target.closest(selector));

      if (isFiller) {
        event.preventDefault();
        setCurrentContextMenu({
          type: ContextMenuTypes.EXPLORER,
          data: {
            mouseEvent: event as unknown as React.MouseEvent
          }
        });
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [
    SELECTORS,
    setCurrentContextMenu
  ]);
};

export default useMuiFillerContextMenu;
